<template>
	<div class="all">
		<form @submit.prevent="submit">
			<div class="row">
				<div class="col-md-12">
					<h4>{{ _traducao('global', 'assinaturaDigital').toUpperCase() }}</h4>
				</div>
			</div>

			<hr style="margin-top: 0px; margin-bottom: 0px" />

			<div class="row">
				<div class="col-xs-12">
					<div class="row" style="margin-top: 16px; margin-bottom: 16px">
						<div class="col-md-4 col-xs-12 text-center">
							<div v-show="foto != ''">
								<img :src="foto" class="foto-troca" />
							</div>

							<div v-show="foto == ''">
								<p :data-letters="nomeReduzido"></p>

								<!-- <div class="div-nome" style="height: 124px;">
                                
                            </div> -->
							</div>
						</div>
						<div class="col-md-8 col-xs-12">
							<h3 style="margin-top: 0px">
								{{ nome }}, {{ _traducao('global', 'porQuestoesDeSeguranca') }}({{ _traducao('global', 'insiraCaso') }}).
							</h3>

							<h3>{{ _traducao('global', 'digiteANovaAssinatura') }}.</h3>

							<!-- <div class="form-group">
                            <label>Login: </label> 
                            <input v-model="login" type="text" disabled="disabled" class="form-control input-sm" />
                        </div> -->
							<div class="form-group" :class="{'has-error': erroSenha != ''}">
								<label>{{ _traducao('global', 'novaAssinatura') }}: </label>
								<div
									class="fa fa-eye icone-senha"
									title="Clique para ver a assinatura"
									@mousedown="inputSenha = true"
									@mouseup="inputSenha = false"
									aria-hidden="true"
								></div>
								<input v-show="inputSenha" type="text" v-mask="'00000000'" v-model="senha" class="form-control input-sm" />
								<input v-show="!inputSenha" type="password" v-mask="'00000000'" v-model="senha" class="form-control input-sm" />
								<!--<input v-model="senha" type="password" class="form-control input-sm" /> -->
								<p class="help-block" v-show="erroSenha != ''">{{ erroSenha }}</p>
								<p class="text-info" style="margin-top: 6px">
									<i class="fa fa-fw fa-info-circle"></i>{{ _traducao('global', 'assinaturaTemQueTer8') }}.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<hr style="margin-top: 0px; margin-bottom: 10px" />

			<div class="row">
				<div class="col-xs-12">
					<button class="btn btn-success pull-right">
						{{ _traducao('global', 'salvar').toUpperCase() }}
						<i class="fa fa-fw fa-check"></i>
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
var jwt_token = require('jwt-decode')

export default {
	data: function () {
		return {
			login: '',
			senha: '',
			erroSenha: '',
			token: '',

			inputSenha: false,

			nomeReduzido: '',
			nome: '',
			foto: ''
		}
	},

	mounted() {
		var self = this

		bus.$on('carrega-trocar-senha', (obj) => {
			//console.log(obj)

			var dados = jwt_token(obj.token)
			self.token = obj.token
			self.nome = dados.nome.split(' ')[0]
			self.login = dados.login
			var nome = dados.nome.split(' ')

			//console.log(dados)

			if (nome.length > 1) {
				self.nomeReduzido = nome[0].substring(0, 1) + nome[1].substring(0, 1)
			} else {
				self.nomeReduzido = nome[0].substring(0, 2)
			}

			if (!_.isNil(dados.foto)) {
				if (dados.foto != '') {
					self.foto = self.getURL_WS('/foto/').replace('public/', '') + dados.foto
				}
			}
		})
	},

	methods: {
		carregaTrocaAssinatura: function (obj) {
			//console.log(obj)

			var dados = jwt_token(obj.token)
			this.token = obj.token
			this.nome = dados.nome.split(' ')[0]
			this.login = dados.login
			var nome = dados.nome.split(' ')

			//console.log(dados)

			if (nome.length > 1) {
				this.nomeReduzido = nome[0].substring(0, 1) + nome[1].substring(0, 1)
			} else {
				this.nomeReduzido = nome[0].substring(0, 2)
			}

			if (!_.isNil(dados.foto)) {
				if (dados.foto != '') {
					this.foto = this.getURL_WS('/foto/').replace('public/', '') + dados.foto
				}
			}
		},

		submit: function () {
			var self = this
			this.senha += ''
			if (this.senha.trim() == '') {
				this.erroSenha = 'Você tem que digitar a assinatura.'
				return false
			} else {
				this.erroSenha = ''
			}

			bus.$emit('load-in', {text: 'Alterando assinatura'})

			var data = {
				login: this.login,
				assinatura: this.senha
			}

			self = this

			////console.log(data, this.token)

			jQuery.ajax({
				type: 'POST',
				headers: {Authorization: this.token},
				url: this.getURL_WS('/Usuario/alterar_assinatura'),
				data: {data: JSON.stringify(data)},
				dataType: 'json',
				success: function (retorno) {
					////console.log(retorno)

					bus.$emit('load-out')

					self.exibirLoad = false

					// deu certo, Login ok!
					if (retorno.status == 'sucesso') {
						self.$emit('alterou-assinatura')
					} else {
						bus.$emit('exibir-notificacao', {type: 'danger', text: 'Não foi possível alterar a assinatura.'})
					}
				},
				error: function (e) {
					//console.log(e);
					//console.log("aii");
					bus.$emit('modal-erro-show', e)
				}
			})
		}
	}
}
</script>